import { Grid, Card, CircularProgress, makeStyles, Typography, MenuItem, Checkbox, FormControlLabel, Button } from '@material-ui/core'
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import ToolbarXLSPDF from '../../../compartidos/ToolbarXLSPDF';
import { useReactToPrint } from 'react-to-print';
import { fetchTipoEfectores, fetchSubTipoEfectores } from '../../../../actions/tipoSubtipoEfectores';
import { fetchProvincias } from '../../../../actions/cbos/provincias';
import { fetchLocalidades } from '../../../../actions/cbos/localidades';
import { getRankingsCartilla } from '../../../../actions/contrataciones/contratacionesCartilla';
import { fetchPrestadores, generateExcelPrestadores, generatePDFPrestadores } from '../../../../actions/contrataciones/contratacionesReportes';
import {
    SelectValidator,
    ValidatorForm,
} from "react-material-ui-form-validator";
import { useForm } from "../../../../hooks/useForm";
import { fetchCentrosMedicosPropios } from '../../../../actions/centrosMedicosPropios';
import DomiciliosPrestacionales from './DomiciliosPrestacionales';
import { fetchEspecialidades } from '../../../../actions/especialidades';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    rootDatos: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        padding: 10,
        marginTop: 20
    },
    button: {
        marginTop: theme.spacing(2),
        float: "right"
    },
    input: {
        display: 'none',
    },
}));

const PrestadoresScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch()

    const { tipoEfectores } = useSelector((state) => state.tipoSubtipoEfectores);
    const { subtipoEfectores } = useSelector((state) => state.tipoSubtipoEfectores);
    const { items: localidades } = useSelector((state) => state.localidades);
    const { items: provincias } = useSelector((state) => state.provincias);
    const { rankingsCartilla } = useSelector((state) => state.contratacionesCartilla);
    const { prestadoresFiltrados, loading } = useSelector(state => state.contratacionesReportes);

    const componentRef = React.useRef();

    const FormInicial = {
        idProvincia: "",
        idLocalidad: "",
        idRanking: "",
        idTipoEfector: "",
        idSubTipoEfector: "",
        inactivos: false
    }

    const [
        formValues,
        handleInputChange,
        ,
        setearValor
    ] = useForm(FormInicial);

    const {
        idProvincia,
        idLocalidad,
        idRanking,
        idTipoEfector,
        idSubTipoEfector,
        inactivos
    } = formValues;

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const onChnageCheckboxInactivos = (e) => {
        setearValor("inactivos", e.target.checked);
    }

    const onSubmitconsultarPrestadores = (e) => {
        e.preventDefault();
        dispatch(fetchPrestadores(formValues.idTipoEfector, formValues.idSubTipoEfector, formValues.idProvincia, formValues.idLocalidad, formValues.idRanking, formValues.inactivos));
    }

    useEffect(() => {
        dispatch(fetchTipoEfectores())
        dispatch(fetchSubTipoEfectores());
        dispatch(fetchProvincias());
        dispatch(fetchLocalidades());
        dispatch(fetchEspecialidades(true));
        dispatch(getRankingsCartilla());
        dispatch(fetchCentrosMedicosPropios())
    }, []);

    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} md={10}>
                    <Card>
                        <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                            <Grid item xs={8}>
                                <Typography variant="subtitle1" style={{ padding: 16 }}>
                                    Listado de Prestadores
                                    {
                                        loading &&
                                        <CircularProgress size={24} style={{ marginLeft: 15 }} />
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                {
                                    <ToolbarXLSPDF
                                        handlePrint={handlePrint}
                                        handleExportExcel={() => dispatch(generateExcelPrestadores(formValues.idTipoEfector, formValues.idSubTipoEfector, formValues.idProvincia, formValues.idLocalidad, formValues.idRanking, formValues.inactivos))}
                                        handleGeneratePdf={() => dispatch(generatePDFPrestadores(formValues.idTipoEfector, formValues.idSubTipoEfector, formValues.idProvincia, formValues.idLocalidad, formValues.idRanking, formValues.inactivos))}
                                    />
                                }
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} style={{ padding: 16 }}>
                            <ValidatorForm
                                onSubmit={onSubmitconsultarPrestadores}
                                style={{ flexGrow: "1", margin: "1rem" }}
                            >
                                <Grid container spacing={1} style={{ padding: 16 }}>
                                    <Grid item xs={4}>
                                        <SelectValidator
                                            onChange={handleInputChange}
                                            value={idTipoEfector}
                                            name="idTipoEfector"
                                            label="Tipo de Contratación"
                                            fullWidth={true}
                                        >
                                            <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                            {
                                                tipoEfectores.map((t) => (
                                                    <MenuItem key={t.idTipoEfector} value={t.idTipoEfector}>
                                                        {t.descripcionTipoEfector}
                                                    </MenuItem>
                                                ))
                                            }
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <SelectValidator
                                            name="idSubTipoEfector"
                                            value={idSubTipoEfector}
                                            label="Subtipo de Contratación"
                                            fullWidth={true}
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                            {
                                                subtipoEfectores.map((t) => (
                                                    <MenuItem key={t.idSubTipoEfector} value={t.idSubTipoEfector}>
                                                        {t.descripcionSubTipoEfector}
                                                    </MenuItem>
                                                ))
                                            }
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <SelectValidator
                                            onChange={handleInputChange}
                                            name="idProvincia"
                                            value={idProvincia}
                                            label="Provincia"
                                            fullWidth={true}
                                        >
                                            <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                            {
                                                provincias.map((t) => (
                                                    <MenuItem key={t.id_provincia} value={t.id_provincia}>
                                                        {t.descripcion_provincia}
                                                    </MenuItem>
                                                ))
                                            }
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <SelectValidator
                                            name="idLocalidad"
                                            value={idLocalidad}
                                            label="Localidades"
                                            fullWidth={true}
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                            {
                                                localidades.map((t) => (
                                                    idProvincia === t.id_provincia &&
                                                    <MenuItem key={t.id_localidad} value={t.id_localidad}>
                                                        {t.descripcion_localidad}
                                                    </MenuItem>
                                                ))
                                            }
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <SelectValidator
                                            name="idRanking"
                                            value={idRanking}
                                            label="Ranking Cartilla"
                                            fullWidth={true}
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                            {
                                                rankingsCartilla.map((t) => (
                                                    <MenuItem key={t.idRankingCartilla} value={t.idRankingCartilla}>
                                                        {t.descripcion}
                                                    </MenuItem>
                                                ))
                                            }
                                        </SelectValidator>
                                    </Grid>
                                    <Grid item xs={4} styile={{ alignSelf: "end" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="inactivos"
                                                    value={inactivos}
                                                    onChange={onChnageCheckboxInactivos}
                                                />
                                            }
                                            label="Traer solo inactivos"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                                    <Grid item xs={2}>
                                        <Button variant="contained" color="primary" type="submit">
                                            Consultar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                        <TableGeneric
                            ref={componentRef}
                            data={prestadoresFiltrados}
                            columns={[
                                {
                                    label: "Código contrato",
                                    id: "idEfectorFacturacion",
                                    sort: true
                                },
                                {
                                    label: "Cuit",
                                    id: "cuit",
                                    sort: true
                                },
                                {
                                    label: "Razón Social",
                                    id: "razonSocial",
                                    sort: true
                                },
                                {
                                    label: "Nombre Fantasía",
                                    id: "nombreFantasia",
                                    sort: true
                                },
                                {
                                    label: "Domicilios Prestacionales",
                                    customBody: (item) => <DomiciliosPrestacionales item={item} />
                                }
                                // {
                                //     label: "Domicilios prestacionales",
                                //     id: "prestadores.cartillaPrestadores.cartillaPrestadoresDomicilio",
                                //     customBody: (item) => (
                                //         <ul>
                                //             {
                                //                 item.prestadores?.map((t) => t.cartillaPrestadores?.map((a) => {
                                //                     if (!a.atiendeCentroPropio) {
                                //                         return <li key={a.idCartillaPrestadores}>{`${a.cartillaPrestadoresDomicilio?.domicilio}, C${a.cartillaPrestadoresDomicilio?.cp} ${localidades.find(x => x.id_localidad === a.cartillaPrestadoresDomicilio?.idLocalidad)?.descripcion_localidad}, ${provincias.find(x => x.id_provincia === a.cartillaPrestadoresDomicilio?.idProvincia)?.descripcion_provincia}`}</li>
                                //                     } else {
                                //                         const centroEncontrado = CentrosMedicos.find(x => x.idCentroMedico === a.idCentroMedico);
                                //                         const localidad = localidades.find(x => x.id_localidad === centroEncontrado.idLocalidad);
                                //                         return <li key={a.idCartillaPrestadores}>{`${centroEncontrado?.descripcionCentro} (${centroEncontrado?.direccion}, C${centroEncontrado?.cp} ${localidades.find(x => x.id_localidad === centroEncontrado?.idLocalidad)?.descripcion_localidad}, ${provincias.find(x => x.id_provincia === localidad?.id_provincia)?.descripcion_provincia} )`}</li>
                                //                     }
                                //                 }))
                                //             }
                                //         </ul>
                                //     )
                                // },
                            ]}
                        />
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}
export default PrestadoresScreen;